module.exports = __webpack_public_path__ + "static/media/24-8.1f43db9b.mp3";